"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frame = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
/* eslint-disable import/prefer-default-export */

var colour = _feBrary.variables.colour;
var frame = exports.frame = /*#__PURE__*/(0, _core.css)("width:fit-content;transition:0.3s ease;", (0, _feBrary.media)('>=desktop'), "{box-shadow:0 20px 40px 0 ", (0, _feBrary.rgba)(colour.black, 0.18), ",0 12px 12px 0 ", (0, _feBrary.rgba)(colour.black, 0.05), ";&:hover{transform:scale(1.06);box-shadow:0 20px 40px 0 ", (0, _feBrary.rgba)(colour.black, 0.36), ",0 12px 12px 0 ", (0, _feBrary.rgba)(colour.black, 0.1), ";}}");